import { useGetFilterQuery, useGetMatchListQuery } from 'hooks/queries/match';
import React from 'react';
import styled from 'styled-components';
import style from 'styles/styled-components/style';

const MatchResultCount = () => {
	const { data: filter_data = null, isLoading: filter_loading } = useGetFilterQuery();
	const { data: match_data = null, isLoading: match_loading } = useGetMatchListQuery();

	return (
		<CountBg>
			{!filter_loading &&
				!match_loading &&
				filter_data &&
				match_data &&
				match_data.results.length > 0 && (
					<style.Text typo="span_bold">
						해당 필터의 연관계정 {match_data.count}건이 발견 되었습니다.
					</style.Text>
				)}
		</CountBg>
	);
};

const CountBg = styled.div`
	width: 100%;
	height: 53px;
	padding: 24px 24px 8px;
	margin-bottom: -24px;

	position: sticky;
	left: 0;

	background-color: ${({ theme }) => theme.colors.gray.gray05_bg};
`;

export default MatchResultCount;
